module.exports = __webpack_public_path__ + "static/media/animal.7c9326ef.jpg";